Directives.CommunityFeedDirective = function communityFeedDirective() {

    // @ngInject
    function communityFeedDirectiveControllerFunc($scope, $injector, UsersManager, $timeout, ConversationService, ConversationsManager, $window, DeviceService, AppConfigService) {


        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'CommunityFeedDirectiveController';

        var self = this;
        this.destroyed = false;
        this.ConversationService = ConversationService;
        this.ConversationsManager = ConversationsManager;
        this.$timeout = $timeout;
        this.UsersManager = UsersManager;
        this.$window = $window;
        this.isMalkut = AppConfigService.isMalkutServer();
        this.isProduction = ConversationService.isProduction;


        this.isMobile = DeviceService.checkIfMobileSize();
        this.initialize = function initialize() {

            this.membersCount = 23;

            this.visible = false;
            this.channelListMode = true;
            this.channelList = ConversationService.getLiveChats();

            this.updateCurrentUser();
            this.conversationId = this.ConversationService.getDefaultLiveChatId();
            this.activeChannel = this.channelList[this.conversationId];
            this.hasUnreadMessages = true;
            this.ConversationService.updateCommunityFeedConversationId(this.conversationId);
            this.updateTitle();
            this.updateChannelListOptInInfo();

        };

        this.UsersManager.on('currentUserChanged', this.updateCurrentUser.bind(this));
        this.ConversationService.on('closeConversation', this.closeChat.bind(this));
        this.ConversationService.on('chatOpened', this.onChatOpened.bind(this));

        this.initialize();
    }

    var communityFeedDirectiveController = Class(Controllers.BaseController, {
        constructor: communityFeedDirectiveControllerFunc,

        toggleChatVisible: function toggleChatVisible() {
            this.visible = !this.visible;

            if (this.visible) {
                this.hasUnreadMessages = false;
                this.chatOpened();
            }
        },

        closeChat: function closeChat() {

            this.visible = false;
            this.ConversationService.unsetOpenConversation();
        },

        cleanUp: function cleanUp() {
            this.closeChat();
        },


        updateCurrentUser: function updateCurrentUser() {

            this.user = this.UsersManager.getCurrUser();
            this.enableLiveChatForCurrentUser = false;

            //we only show live feed to vendors who already sent a file (not fresh trialers)
            if (this.user && this.user.isVendor() && (this.user.last_file_sent_time || this.user.isHBInvoicing())) {
                this.enableLiveChatForCurrentUser = true;
            }
        },

        updateTitle: function updateTitle(){

            if(this.channelListMode){
                this.title = 'Discover Co-Creative Channels';
                this.subtitle = 'Connect with other HoneyBook members in real time';
            }else{
                this.title = this.activeChannel.name;
                this.subtitle = this.activeChannel.description;
            }
        },

        updateChannelListOptInInfo: function updateChannelListOptInInfo(){
            var channelHash = {};
            if(this.user.opted_in_live_feed_channels){
                for(var channelId in this.user.opted_in_live_feed_channels){
                    channelHash[channelId] = true;
                }
            }

            for(var channelName in this.channelList){
                var channel = this.channelList[channelName];

                if(channel.opt_in && channelHash[channel.id]){
                    channel.opt_in = false;
                }
            }
        },

        channelSelected: function channelSelected(channelIdentifier){

            this.channelListMode = false;
            this.activeChannel = this.channelList[channelIdentifier];
            this.conversationId = this.activeChannel.id;
            this.updateTitle();

            // if this is an opt in channel, we update that this user has opted in
            if(this.activeChannel.opt_in){
                this.ConversationsManager.optIntoConversation(this.activeChannel.id).then(this.updateChannelListOptInInfo.bind(this));
            }

            this.ConversationService.updateCommunityFeedConversationId(this.activeChannel.id);
        },

        goToChannelList: function goToChannelList(){

            this.channelListMode = true;
            this.updateTitle();
        },

        requestChannel: function requestChannel(){

            this.$window.open('https://s3.amazonaws.com/honeybook_cdn/assets_system/system_web/community_chat/New_channel_request/new-channel-form.html?email=' + this.user.email,
                '_blank',
                'resizable=yes, scrollbars=yes, titlebar=yes, width=400, height=630')
        },

        chatOpened: function chatOpened() {
            this.$timeout(function timedOut() {
                this.ConversationService.chatOpened(this.conversationId);
            }.bind(this), 0);

        },

        onChatOpened: function onChatOpened(conversationId) {
            if (conversationId !== this.conversationId) {
                this.closeChat();
            }
        },

        newUnreadMessages: function newUnreadMessages(){
            this.hasUnreadMessages = true;
        },

        updateConversationLoaded: function updateConversationLoaded(){
            this.conversationLoaded = true;
        },

        membersCountUpdated: function membersCountUpdated(count){
            if(this.conversationId === this.ConversationService.getDefaultLiveChatId()){
                this.membersCount = count;
            }
        }

    });

    return {
        controller: communityFeedDirectiveController,
        bindToController: true,
        controllerAs: 'communityFeedVm',
        restrict: 'AE',
        templateUrl: 'angular/app/modules/core/features/chat/community_feed_directive_template.html'
    };
}
;
